import fetchApi from '../fetch/fetchApi'

const fetchGraphQL = (body) => fetchApi({ body })
  .then(({ data }) => data)

export default fetchGraphQL
